export const API_ERROR_CODES = {
    ORDER_CREATE_FAILED: 'ORDER_CREATE_FAILED',
    INVALID_PARAMS: 'invalid_params',
    USER_PLAYED_MAXIMUM_COUNT: 'user_played_maximum_count',
    ALREADY_EXIST_USER: 'already_exist_user',
    UNKNOWN_USER: 'unknown_user',
    NOT_EXIST_PLAYABLE_COUNT: 'not_exist_playable_count',
};
export const API_ERROR_DESCRIPTIONS = {
    ORDER_CREATE_FAILED: {
        title: '注文を作成できませんでした',
        description: '時間をおいて再度お試しください。',
    },
    INVALID_PARAMS: {
        title: 'パラメータが不正です',
        description: '住所と決済方法を確認してください。',
    },
    USER_PLAYED_MAXIMUM_COUNT: {
        title: '本日の購入上限に達しています',
        description: '翌日再度お試しください。購入回数は日本時間で午前5時にリセットされます。',
    },
    ALREADY_EXIST_USER: {
        title: '既に存在するユーザです',
        description: 'ログインしてください。',
    },
    UNKNOWN_USER: {
        title: 'ユーザが見つかりませんでした',
        description: '新規登録を行ってください。',
    },
    NOT_EXIST_PLAYABLE_COUNT: {
        title: '在庫が足りないため、注文できませんでした',
        description: 'ガチャの在庫が少なくなっているか、売り切れの可能性があります',
    },
};
